import { actions } from '../actionTypes';
import { checkBucketsAvailability } from 'api/buckets';

export interface IBucketStore {
  staticBucketReachable?: boolean;
  watermarkedBucketReachable?: boolean;
}

export const initialBucketState: IBucketStore = {
  staticBucketReachable: true,
  watermarkedBucketReachable: true,
};

const buckets = (state: IBucketStore = initialBucketState, action): IBucketStore | undefined => {
  switch (action.type) {
    case actions.FETCH_BUCKET_AVAILABLILITY: {
      return {
        ...state,
        ...action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export async function testBucketsAvailability(dispatch /* , getState */) {
  try {
    const ret = await checkBucketsAvailability(true);

    dispatch({ type: actions.FETCH_BUCKET_AVAILABLILITY, payload: ret });
  } catch (error) {
    dispatch({ type: actions.FETCH_BUCKET_AVAILABLILITY_ERROR, payload: error });
  }
}

export default buckets;
